var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 15,
    viewBox: "0 0 38.93 25.953",
    className: " relative bottom-10 left-72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M38.695,16.49A21.678,21.678,0,0,0,19.465,4.5,21.681,21.681,0,0,0,.235,16.491a2.186,2.186,0,0,0,0,1.973,21.678,21.678,0,0,0,19.23,11.99,21.681,21.681,0,0,0,19.23-11.991A2.186,2.186,0,0,0,38.695,16.49ZM19.465,27.209A9.732,9.732,0,1,1,29.2,17.477,9.732,9.732,0,0,1,19.465,27.209Zm0-16.221a6.442,6.442,0,0,0-1.711.256,3.234,3.234,0,0,1-4.522,4.522,6.473,6.473,0,1,0,6.232-4.778Z",
    transform: "translate(0 -4.5)",
    fill: "#7e84a3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f4677efed5ab9ab2eba5de99e3feab2f.svg";
export { ForwardRef as ReactComponent };